import { render, staticRenderFns } from "./mt-input.vue?vue&type=template&id=88ab2c2e&scoped=true&"
import script from "./mt-input.vue?vue&type=script&lang=js&"
export * from "./mt-input.vue?vue&type=script&lang=js&"
import style0 from "./mt-input.vue?vue&type=style&index=0&id=88ab2c2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ab2c2e",
  null
  
)

export default component.exports